export default __webpack_public_path__ + "static/media/preference content3.6c816083.jpg";